module.exports = __webpack_public_path__ + "images/icon-512x512_0bdd553.png";